import { defineAsyncComponent } from 'vue'
export default {
  campaign: defineAsyncComponent(() => import("/app/layouts/campaign.vue").then(m => m.default || m)),
  custom: defineAsyncComponent(() => import("/app/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  diaspora: defineAsyncComponent(() => import("/app/layouts/diaspora.vue").then(m => m.default || m))
}